import { StylesProvider, jssPreset } from "@material-ui/core/styles";
import React, { useCallback, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { useStyles } from "features/admin/styles";
import DrawerAdmin from "components/Admin/Drawer/DrawerAdmin";
import AppBarAdmin from "components/Admin/AppBar/AppBarAdmin";
import AdminRouter from "routers/AdminRouter";
import CompareMessage from "features/message/Message";
import { selectResponse, setResponseMessage } from "features/admin/adminSlice";
import { setMessage } from "features/message/messageSlice";
import { MessageType } from "features/message/types";
import { useSelector, useDispatch, batch } from "react-redux";
import { create } from "jss";

const AdminLayout = () => {
  const classes = useStyles();
  const response = useSelector(selectResponse);
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const setResponse = useCallback(() => {
    if (response.message !== "") {
      batch(() => {
        dispatch(setResponseMessage({ message: "", hasError: false }));
        dispatch(
          setMessage({
            text: response.message,
            type: response.hasError && response.hasError === true ? MessageType.danger : MessageType.info,
          })
        );
      });
    }
  }, [dispatch, response]);

  useEffect(() => {
    response && setResponse();
  }, [response, setResponse]);

  const jss = create({
    ...jssPreset(),
    // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
    insertionPoint: "jss-insertion-point",
  });
  return (
    <StylesProvider jss={jss}>
      <div className={classes.root}>
        <CssBaseline />
        <CompareMessage />
        {/* reset all styles */}
        <AppBarAdmin handleDrawerOpen={handleDrawerOpen} open={open} />
        <DrawerAdmin handleDrawerClose={handleDrawerClose} open={open} />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <AdminRouter />
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    </StylesProvider>
  );
};

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright ©  I-Clima.bg "}

      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

export default AdminLayout;
